<script setup lang="ts">
import { useAuthStore } from '@/stores/authStore'
import { useRouter } from 'vue-router'
const router = useRouter()
const authStore = useAuthStore()

authStore.checkWithServer().then((profile) => {
  if (profile) router.push('/')
  else router.push('/login')
})
</script>

<template>
  <q-card
    class="vertical-middle text-white shadow-12"
    style="background: radial-gradient(circle, #35a2ff 0%, #014a88 100%); min-width: 600px"
    bordered
  >
    <q-card-section>
      <h4 class="text-black">Checking with the league of heros</h4>
    </q-card-section>
    <q-separator dark inset />
  </q-card>
</template>
